import { PluginFunc } from 'dayjs'

const ISO_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ssZ'
const ISO_DATE_FORMAT = 'YYYY-MM-DD'

const timezoneHelpers: PluginFunc = (_, dayjsClass) => {
  dayjsClass.prototype.toTzDate = function () {
    const localOffset = this.utcOffset()
    const timezoneOffset = this.tz().utcOffset()

    return this.subtract(localOffset - timezoneOffset, 'minutes').toDate()
  }

  dayjsClass.prototype.toTzISOString = function (withTime = true) {
    if (withTime) {
      return this.tz().format(ISO_DATETIME_FORMAT)
    } else {
      return this.format(ISO_DATE_FORMAT)
    }
  }
}

export default timezoneHelpers
